import React from 'react';
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	Typography,
} from '@mui/material';

interface ConfirmationDialogProps {
	open: boolean;
	onClose: () => void;
	onConfirm: () => void;
	title?: string;
	description?: string;
	confirmText?: string;
	cancelText?: string;
	loading?: boolean;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
	open,
	onClose,
	onConfirm,
	title = 'Confirm Action',
	description = 'Are you sure you want to proceed? This action cannot be undone.',
	confirmText = 'Confirm',
	cancelText = 'Cancel',
	loading = false,
}) => {
	return (
		<Dialog open={open} onClose={loading ? undefined : onClose}>
			<DialogTitle>{title}</DialogTitle>
			<DialogContent>
				<Typography>{description}</Typography>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} variant="outlined" disabled={loading}>
					{cancelText}
				</Button>
				<Button
					onClick={onConfirm}
					color="error"
					variant="contained"
					disabled={loading}
				>
					{loading ? 'Processing...' : confirmText}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default ConfirmationDialog;
